var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-file-flag-status"},[(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.color,"left":"","size":"20"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }